<template>
<span>
  <span class="badge badge-primary ml-1" data-toggle="modal" :data-target="`#exampleModal${video_id}`" @click="show">
    サムネイル
  </span>
  <!-- Modal -->
  <div class="modal fade" :id="`exampleModal${video_id}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-fluid" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <img v-lazy="thumbnail" class="img-fluid">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</span>
</template>

<script>

export default {
  name: "ScreenshotModalComponent",
  props: ['video_id'],
  data() {
    return {
      thumbnail: '',
    }
  },
  methods: {
    show () {
      console.log('show =' + this.video_id);
      this.csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      this.thumbnail = '/api/screenshots/' + this.video_id;
    }
  },
  created () {
    console.log('video_id = ' + this.video_id);
  }
}
</script>

<style type="text/css">
  .modal-dialog-fluid {
    max-width: inherit;
    width: 98%;
    margin-left: 15px;
  }
</style>